/* eslint-disable max-len */
import { find, get } from "lodash";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import * as action from "~/store/resource/resourceAction";
import { Delpath } from "~/utils/constants";
import { NonUpBeta } from "~/utils/func";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const IntroducePageDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/Introduce"),
  loading: LoadableLoading
});
const IntroducePageTestDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/IntroduceTest"),
  loading: LoadableLoading
});
class Introduce extends Component {
  // constructor(props) {
  //   super(props);
  // this.props.getIntroduction();
  // }

  componentDidMount() {
    // if (NonUpBeta()) {
    const pathName = Delpath(this.props.location.pathname);
    this.props.requestContentPages(pathName);
    // }
  }

  render() {
    return (
      <React.Fragment>
        <IntroducePageTestDesktop {...this.props} />
        {/*{NonUpBeta() ? (*/}
        {/*  <IntroducePageTestDesktop {...this.props} />*/}
        {/*) : (*/}
        {/*  <IntroducePageDesktop {...this.props} />*/}
        {/*)}*/}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    resource: { loading, data, error, ContentPages }
  } = state;
  return {
    device: type,
    loading,
    data,
    error,
    ContentPages
  };
};

const mapDispatchToProps = dispatch => {
  return {
    // getIntroduction: () => dispatch(action.getIntroduction()),
    requestContentPages: pathName =>
      dispatch(action.requestContentPages(pathName))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Introduce);
